import { render, staticRenderFns } from "./VideoCategories.vue?vue&type=template&id=11ceeb48&scoped=true"
import script from "./VideoCategories.vue?vue&type=script&lang=js"
export * from "./VideoCategories.vue?vue&type=script&lang=js"
import style0 from "./VideoCategories.vue?vue&type=style&index=0&id=11ceeb48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ceeb48",
  null
  
)

export default component.exports